var app = angular.module('myApp', ['ngRoute', 'ui.bootstrap', 'ngCookies', 'logToServer', 'ng.deviceDetector', 'rzModule']);
app.config(['$routeProvider', function ($routeProvider) {

    $routeProvider
        .when('/', {
            redirectTo: '/home'
        })
        .when('/paymentcancel', {
            templateUrl: '../app/modules/upgradeService/paymentDecline.html',
            controller: 'paymentDeclineController'
        })
        .when('/home', {
            templateUrl: '../app/modules/home/home.html',
            controller: 'indexController'
        })
        .when('/invite', {
            templateUrl: '../app/modules/invite/invite.html',
            controller: 'inviteController'
        })
        .when('/profile', {
            templateUrl: '../app/modules/profile/profile.html',
            controller: 'profileController'
        })
        .when('/passwordResetConfirmation', {
            templateUrl: '../app/modules/profile/passwordResetConfirmation.html',
            controller: 'inviteController'
        })
        .when('/landing', {
            templateUrl: '../app/modules/landing/landing.html',
            controller: 'landingController'
        })
        .when('/registrationsuccess', {
            templateUrl: '../app/modules/login/registrationsuccessful.html',
            controller: 'registerController'
        })
        .when('/admin/storagemanagement', {
            templateUrl: '../app/modules/admin/storagemanagement/storagemanagement.html',
            controller: 'storagemanagementController'
        })
        .when('/admin/usermanagement', {
            templateUrl: '../app/modules/admin/usermanagement/usermanagement.html',
            controller: 'usermanagementController'
        })
        .when('/admin/landing', {
            templateUrl: '../app/modules/admin/landing/landing.html',
            controller: 'adminLandingController'
        })
        .when('/welcome/:userId', {
            templateUrl: '../app/modules/welcome/welcome.html',
            controller: 'registerController'
        })
        .when('/datamanagement', {
            templateUrl: '../app/modules/datamanagement/datamanagement.html',
            controller: 'datamanagementController'
        })
        .when('/datamanagement/:mode', {
            templateUrl: '../app/modules/datamanagement/datamanagement.html',
            controller: 'datamanagementController'
        })
        .when('/search', {
            templateUrl: '../app/modules/search/search.html',
            controller: 'searchcontroller'
        })
        .when('/teamManagement', {
            templateUrl: '../app/modules/teamManagement/teamManagement.html',
            controller: 'teamManagementController'
        })
        .when('/search/:mode', {
            templateUrl: '../app/modules/search/search.html',
            controller: 'searchcontroller'
        })
        //.when('/upgradeService', {
        //    templateUrl: '../app/modules/upgradeService/upgradeService.html',
        //    controller: 'upgradeServiceController'
        //})
        .when('/assignlicensekey', {
            templateUrl: '../app/modules/upgradeService/assignLicenceKey.html',
            controller: 'assignLicenseController'
        })
        .when('/thankYou', {
            templateUrl: '../app/modules/upgradeService/thankYou.html',
            controller: 'thankYouController'
        })
        .when('/licenseThankYou', {
            templateUrl: '../app/modules/upgradeService/licenceThankYou.html'
        })
        .when('/plotgraph', {
            templateUrl: '../app/modules/plotgraph/plotgraph.html',
            controller: 'plotgraphcontroller'
        })
        .when('/plotgraph?workspacedid', {
            templateUrl: '../app/modules/plotgraph/plotgraph.html',
            controller: 'plotgraphcontroller'
        })
        .when('/login', {
            templateUrl: '../app/modules/login/login.html',
            controller: 'registerController'
        })
        .when('/login/:userId', {
            templateUrl: '../app/modules/login/login.html',
            controller: 'registerController'
        })
        .when('/register', {
            templateUrl: '../app/modules/login/login.html',
            controller: 'registerController'
        })
        .when('/register/:invitedEmail', {
            templateUrl: '../app/modules/login/login.html',
            controller: 'registerController'
        })
        .when('/resetPassword/:userId/:resetCode', {
            templateUrl: '../app/modules/resetPassword/resetPassword.html',
            controller: 'resetPasswordController'
        })
        .when('/saveuser', {
            templateUrl: '../app/modules/user/saveuser.html',
            controller: 'usercontroller'
        })

        .when('/usermanual', {
            templateUrl: '../app/modules/user/usermanual.html',
            controller: 'usermanualcontroller'
        })
        .when('/savedWorkedSpace', {
            templateUrl: '../app/modules/workspace/savedworkspace.html',
            controller: 'savedworkspacecontroller'
        })
        .when('/saveworkspace', {
            templateUrl: '../app/modules/workspace/saveworkspace.html',
            controller: 'savedworkspacecontroller'
        })
        //.when('/admin/systemAdmins', {
        //    templateUrl: '../app/modules/admin/adminManagement/adminManagement.html',
        //    controller: 'adminManagementController'
        //})
        //.when('/admin/systemAdmins/:userId', {
        //    templateUrl: '../app/modules/admin/adminManagement/adminManagement.html',
        //    controller: 'adminManagementController'
        //})
        .when('/admin/discountCodeManagement', {
            templateUrl: '../app/modules/admin/discountCodeManagement/discountCodeManagement.html',
            controller: 'discountCodeManagementController'
        })
        .when('/subscriptionReport', {
            templateUrl: '../app/modules/report/subscriptionReport.html',
            controller: 'subscriptionReportController'
        })
        .when('/admin/teamManagement', {
            templateUrl: '../app/modules/admin/teamManagement/teamManagement.html',
            controller: 'adminTeamManagementController'
        })
        .when('/notfound', {
            templateUrl: '../app/modules/error/notfound.html',
        })
        .when('/privacypolicy', {
            templateUrl: '../app/modules/privacyPolicy/privacypolicy.html',
        })
        .when('/legal', {
            templateUrl: '../app/modules/privacyPolicy/legal.html',
        })
        .when('/error', {
            templateUrl: '../app/modules/error/sorry.html',
        })
        .when('/idleTimeout', {
            templateUrl: '../app/modules/error/idleTimeout.html',
        })
        .when('/account', {
            templateUrl: '../app/modules/account/userAccount.html',
            controller: 'userAccountController'
        })
        .when('/internal', {
            templateUrl: '../app/modules/admin/aippEmployeeRegistration/internalRegistration.html',
            controller: 'internalRegistrationController'
        })
        .when('/internalSuperadmin', {
            templateUrl: '../app/modules/admin/aippEmployeeRegistration/internalSuperadminRegistration.html',
            controller: 'internalRegistrationController'
        })
        .when('/internalTeam', {
            templateUrl: '../app/modules/admin/aippTeamRegistration/internalTeamRegistration.html',
            controller: 'internalTeamRegistrationController'
        })
        .when('/contactUs', {
            templateUrl: '../app/modules/contactUs/contactUs.html',
            controller: 'contactUsController'
        })
        .when('/ccupdatesuccess', {
            templateUrl: '../app/modules/upgradeService/UpdateCCSuccessful.html',
            controller: 'updateCCController'
        })
        .when('/ccupdatecancel', {
            templateUrl: '../app/modules/upgradeService/UpdateCCInformationError.html',
            controller: 'cancelUpdateCCController'
        })
        .when('/payementError', {
            templateUrl: '../app/modules/error/paymentError.html',
        })
        .when('/accessOption', {
            templateUrl: '../app/modules/accessOption/accessOption.html',
            controller: 'accessOptionController'
        })
        .when('/accessOption/:accessType', {
            templateUrl: '../app/modules/accessOption/accessOption.html',
            controller: 'accessOptionController'
        })
        .when('/indBulkSubscribe/:accessType', {
            templateUrl: '../app/modules/accessOption/bulkIndSubscription.html',
            controller: 'indBulkPurchaseController'
        })
        .when('/partner', {
            templateUrl: '../app/modules/partner/partners.html'
        })
        .otherwise({
            redirectTo: '/notfound'
        });
}])
.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('authInterceptorService');
    $httpProvider.interceptors.push('logToServerInterceptor');
    $httpProvider.interceptors.push('noCacheInterceptor');

    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';


}])
.run(['$route', '$rootScope', '$location', '$cookieStore', '$http', '$window', '$cookies', 'progressBarService',
    function ($route, $rootScope, $location, $cookieStore, $http, $window, $cookies, progressBarService) {

        var lastDigestRun = new Date();
        setInterval(function () {
            var now = Date.now();

            if ($cookies.get('TokenInfo') != undefined) {
                if (now - lastDigestRun > 30 * 60 * 1000) {
                    //logout
                    var cookies = $cookies.getAll();
                    angular.forEach(cookies, function (v, k) {
                        $cookies.remove(k);
                    });
                    localStorage.clear();
                    $rootScope.$broadcast('logoutSuccess', 'true');
                    $location.path('/idleTimeout');
                    $rootScope.$apply();
                }
            }
        }, 60 * 1000);

        $rootScope.$watch(function () {
            lastDigestRun = new Date();
        });

        if ($rootScope.globalConfig == null) {
            $.ajax({
                url: './assets/misc/config.global.json',
                async: false,
                type: "GET",
                dataType: "json"
            }).success(function (data) {
                $rootScope.globalConfig = data;
            }).error(function (request, status, error) {
                console.log("error:" + error)
            });
        }

        if ($rootScope.buildConfig == null) {
            $.ajax({
                url: './assets/misc/build.config.json',
                async: false,
                type: "GET",
                dataType: "json"
            }).success(function (data) {
                $rootScope.buildConfig = data;
            }).error(function (request, status, error) {
                console.log("error:" + error)
            });
        }

        $rootScope.$on('$routeChangeStart', function (scope, next, current) {
            $('.modal').modal('hide');
            progressBarService.hideProgressBar();

            var tokenInfo = $cookies.get("TokenInfo");
            if ((tokenInfo != undefined) && (tokenInfo != null) && (tokenInfo != "")) {
                tokenInfo = JSON.parse($cookies.get("TokenInfo"));
                $.ajaxSetup({
                    headers: {
                        'Authorization': 'Bearer ' + tokenInfo
                    }
                });
            }

            if (current != undefined) {
                if (next.$$route.originalPath.indexOf("accessOption") <= 0) {
                    setLocalValue("teamPartyID", '0');
                }
            }

            if (current != undefined && current.$$route.originalPath.indexOf('teamManagement') > 0) {
                setLocalValue("origPath", "teamManagement");
            } else if (current != undefined && current.$$route.originalPath.indexOf('usermanagement') > 0) {
                setLocalValue("origPath", "usermanagement");
            }

            if (current != undefined && current.$$route.originalPath.indexOf('plotgraph') > 0) {
                setLocalValue("isRedirectedFromPlotgraph", true);
            } else {
                setLocalValue("isRedirectedFromPlotgraph", false);
            }

            if ($location.$$path == '/admin/landing' && getLocalValue('userRole') != 'SAdmin') {
                $location.path('/login');
            }
            else {
                if ($location.$$path == '/home') {
                    $('#eSpectraTitle').hide();
                    $('#titleNavBar').removeClass('mheight-40px')
                    $('#titleNavBar').addClass('mheight-5px')
                } else {
                    $('#eSpectraTitle').show();
                    $('#titleNavBar').addClass('mheight-40px')
                    $('#titleNavBar').removeClass('mheight-5px')
                }
                if (next.$$route.originalPath.indexOf("login") >= 0) {
                    $rootScope.currentTab = 1;
                }
                else if (next.$$route.originalPath.indexOf("register") >= 0) {
                    $rootScope.currentTab = 2;
                }

                if ($rootScope.globalConfig != null) {

                    progressBarService.showProgressBar();
                    var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;

                    $http({
                        method: "GET",
                        url: serviceBase + "underMaintenance",
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).success(function (data, headers, status) {
                        if (data == "1" && next.$$route.originalPath.indexOf("login") < 0 && getLocalValue('maintenanceFlag') != "1") {
                            var cookies = $cookies.getAll();
                            angular.forEach(cookies, function (v, k) {
                                $cookies.remove(k);
                            });
                            localStorage.clear();
                            $window.location.href = '/app/modules/error/' + $rootScope.globalConfig.underMaintenancePage;
                        }

                        progressBarService.hideProgressBar();
                    })
                }
            }
        });
    }]);

app.factory('noCacheInterceptor', function () {
    return {
        request: function (config) {

            if (config.method == 'GET') {
                if (config.url.indexOf('html') == -1) {
                    var separator = config.url.indexOf('?') === -1 ? '?' : '&';
                    config.url = config.url + separator + 'noCache=' + new Date().getTime();
                }
            }

            return config;
        }
    };
});
app.factory("progressBarService", ["$timeout", function ($timeout) {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    return {

        showProgressBar: function () {

            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {
                angular.element(document.getElementsByClassName("page-spinnerIE")).show();
            }
            else {
                angular.element(document.getElementsByClassName("page-spinner")).show();
            }
        },

        hideProgressBar: function () {
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
            {
                angular.element(document.getElementsByClassName("page-spinnerIE")).hide();

            }
            else {

                angular.element(document.getElementsByClassName("page-spinner")).hide();
            }
        }
    };
}])

app.directive('sliderRange', ['$document', function ($document) {

    // Move slider handle and range line
    var moveHandle = function (handle, elem, posX) {
        $(elem).find('.handle.' + handle).css("left", posX + '%');
    };
    var moveRange = function (elem, posMin, posMax) {
        $(elem).find('.range').css("left", posMin + '%');
        $(elem).find('.range').css("width", posMax - posMin + '%');
    };

    return {
        template: '<div class="slider horizontal">' +
                    '<div class="range"></div>' +
                    '<a class="handle min" ng-mousedown="mouseDownMin($event)"></a>' +
                    '<a class="handle max" ng-mousedown="mouseDownMax($event)"></a>' +
                  '</div>',
        replace: true,
        restrict: 'E',
        scope: {
            valueMin: "=",
            valueMax: "="
        },
        link: function postLink(scope, element, attrs) {
            // Initilization
            var dragging = false;
            var startPointXMin = 0;
            var startPointXMax = 0;
            var xPosMin = 0;
            var xPosMax = 0;
            var settings = {
                "min": (typeof (attrs.min) !== "undefined" ? parseInt(attrs.min, 10) : 0),
                "max": (typeof (attrs.max) !== "undefined" ? parseInt(attrs.max, 10) : 100),
                "step": (typeof (attrs.step) !== "undefined" ? parseInt(attrs.step, 10) : 1)
            };
            if (typeof (scope.valueMin) == "undefined" || scope.valueMin === '')
                scope.valueMin = settings.min;

            if (typeof (scope.valueMax) == "undefined" || scope.valueMax === '')
                scope.valueMax = settings.max;

            // Track changes only from the outside of the directive
            scope.$watch('valueMin', function () {
                if (dragging) return;
                xPosMin = (scope.valueMin - settings.min) / (settings.max - settings.min) * 100;
                if (xPosMin < 0) {
                    xPosMin = 0;
                } else if (xPosMin > 100) {
                    xPosMin = 100;
                }
                moveHandle("min", element, xPosMin);
                moveRange(element, xPosMin, xPosMax);
            });

            scope.$watch('valueMax', function () {
                if (dragging) return;
                xPosMax = (scope.valueMax - settings.min) / (settings.max - settings.min) * 100;
                if (xPosMax < 0) {
                    xPosMax = 0;
                } else if (xPosMax > 100) {
                    xPosMax = 100;
                }
                moveHandle("max", element, xPosMax);
                moveRange(element, xPosMin, xPosMax);
            });

            // Real action control is here
            scope.mouseDownMin = function ($event) {
                dragging = true;
                startPointXMin = $event.pageX;

                // Bind to full document, to make move easiery (not to lose focus on y axis)
                $document.on('mousemove', function ($event) {
                    if (!dragging) return;

                    //Calculate handle position
                    var moveDelta = $event.pageX - startPointXMin;

                    xPosMin = xPosMin + ((moveDelta / element.outerWidth()) * 100);
                    if (xPosMin < 0) {
                        xPosMin = 0;
                    } else if (xPosMin > xPosMax) {
                        xPosMin = xPosMax;
                    } else {
                        // Prevent generating "lag" if moving outside window
                        startPointXMin = $event.pageX;
                    }
                    scope.valueMin = Math.round((((settings.max - settings.min) * (xPosMin / 100)) + settings.min) / settings.step) * settings.step;
                    scope.$apply();

                    // Move the Handle
                    moveHandle("min", element, xPosMin);
                    moveRange(element, xPosMin, xPosMax);
                });
                $document.mouseup(function () {
                    dragging = false;
                    $document.unbind('mousemove');
                    $document.unbind('mousemove');
                });
            };

            scope.mouseDownMax = function ($event) {
                dragging = true;
                startPointXMax = $event.pageX;

                // Bind to full document, to make move easiery (not to lose focus on y axis)
                $document.on('mousemove', function ($event) {
                    if (!dragging) return;

                    //Calculate handle position
                    var moveDelta = $event.pageX - startPointXMax;

                    xPosMax = xPosMax + ((moveDelta / element.outerWidth()) * 100);
                    if (xPosMax > 100) {
                        xPosMax = 100;
                    } else if (xPosMax < xPosMin) {
                        xPosMax = xPosMin;
                    } else {
                        // Prevent generating "lag" if moving outside window
                        startPointXMax = $event.pageX;
                    }
                    scope.valueMax = Math.round((((settings.max - settings.min) * (xPosMax / 100)) + settings.min) / settings.step) * settings.step;
                    scope.$apply();

                    // Move the Handle
                    moveHandle("max", element, xPosMax);
                    moveRange(element, xPosMin, xPosMax);
                });

                $document.mouseup(function () {
                    dragging = false;
                    $document.unbind('mousemove');
                    $document.unbind('mousemove');
                });
            };
        }
    };
}]);